module.exports = __webpack_public_path__ + "img/base_divers_marche.4561d2ea.svg";